import { render, staticRenderFns } from "./LessonPreparation2.vue?vue&type=template&id=206fb285&scoped=true&"
import script from "./LessonPreparation2.vue?vue&type=script&lang=js&"
export * from "./LessonPreparation2.vue?vue&type=script&lang=js&"
import style0 from "./LessonPreparation2.vue?vue&type=style&index=0&id=206fb285&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206fb285",
  null
  
)

export default component.exports